export const menuItems = [
  { label: "home", path: "/" },
  { label: "submitVideo", path: "/submitVideo" },
  { label: "videoLibrary", path: "/library" },
  { label: "ugcProduction", path: "/ugc-production" },
  { label: "forMedia", path: "/for-media" },
  { label: "aboutUs", path: "/aboutUs" },
  {
    label: "contactUs",
    path: "/contactUs",
  },
];
